<template>
    <div>
        <v-dialog v-model="ratingdialog" max-width="900px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mt-4 mb-3 ml-1" @click="newItem" v-on="on">+</v-btn>
          </template>
          <v-card>
            <v-card-title>
            <span class="headline mb-4">
                {{ isEdit ? $t('Setupratingset.editratingdetails') : $t('Setupratingset.ratingdetails') }}
            </span>
            </v-card-title>
            <v-card-text>
              <v-container>
                    <v-row>
                      <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                        <v-text-field
                            outlined
                            :label="this.$t('Setupratingset.rating')"
                            type="text"
                            :rules="[rules.required]"
                            v-model="formData.rating"
                            dense
                            class="v-input"
                        ></v-text-field>
                    </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="4" sm="8" class="pb-n4 mt-n8">
                        <v-text-field
                            outlined
                            :label="this.$t('Setupratingset.label')"
                            type="text"
                            :rules="[rules.required]"
                            v-model="formData.label"
                            dense
                            class="v-input"
                        ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="4" sm="8" class="pb-n4 mt-n8">
                        <v-text-field
                            outlined
                            :label="this.$t('Setupratingset.ratingdescription')"
                            type="text"
                            :rules="[rules.required]"
                            v-model="formData.description"
                            dense
                            class="v-input"
                        ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                        <v-text-field
                            outlined
                            :label="this.$t('Setupratingset.score')"
                            type="number"
                            :rules="[rules.required]"
                            v-model="formData.score"
                            dense
                            class="v-input"
                        ></v-text-field>
                        </v-col>
                    </v-row>
            </v-container>
            </v-card-text>

            <v-card-text v-if="isErr" class="mt-n12">
                <span style="font-weight: bold; color: red">{{errMsg}}</span>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="saveRatingInput">{{$t('button.save')}}</v-btn>
              <v-btn color="red darken-1" text @click="closeRatingInput">{{$t('button.cancel')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog> 

        <div style="overflow-x: auto; width: 100%;">
        <v-data-table
            style="width:100%;"
            :headers="this.parentObject.tabHeader"
            :items="detailItem"
            class="elavation-1"
:sort-by="['code']"
        >
            <template v-slot:[`item.action`]="{ item }">
                <v-icon
                    small
                    class="mr-2"
                    @click="modifyItemHandler(item)"
                >
                    mdi-pen
                </v-icon>
                <v-icon
                    small
                    class="ml-3 mr-2"
                    @click="deleteItemHandler(item)"
                >
                    mdi-delete
                </v-icon>
            </template>

            <div v-if="isErr">
            <app-error
                v-bind:parentError="{
                data: this.errMsg,
                isErr: this.isErr,
                }"
                v-on:closeError="isErr = $event"
            />
            </div>

        </v-data-table>
        </div>
    </div>
</template>

<script>
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
    props: {
        parentObject: Object
    },

    components: {
        "app-error": ErrorDialog,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            ratingdialog: false,
            detailItem: this.parentObject.detailItem,
         
            formData: {
                pmratesetid: this.parentObject.pmratesetid,
                rating: null,
                label: null,
                description: null,
                score: null,
                rectimestamp: null,
                updatedby: this.$store.getters.userId,
                stamp: 0,
                userid: this.$store.getters.userId,
            },

            isEdit: false,

            //error msg and dialog, check for duplicates vars
            isErr: false,
            errMsg: '',
        }
    },

    methods: {
        newItem() {
            this.isExisting = false;
            this.modify = false;
            this.resetSelections();
        },
        modifyItemHandler(item) {
            this.isEdit = true;
            this.ratingdialog = true;
            Object.assign(this.formData, item);
        },

        deleteItemHandler(item) {
            const vm = this;

            if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
                return false;
            }

            if (confirm(this.$t('pmratingset.deleterating', { code: item.rating }))) {
                this.$store.dispatch('delete', {url: "/ratingsetdetails/" + item.id})
                .then(function () {
                    const index = vm.detailItem.findIndex(detail => detail.id === item.id);
                    if (index !== -1) {
                        vm.detailItem.splice(index, 1);
                    }
                })
                .catch(function (err) {
                    vm.errMsg = err;
                });
            }
        },

        saveRatingInput() {
            const vm = this;

            if (this.isEdit) {//Edit
                if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
                    return false;
                }

                this.$store.dispatch('put', {url: "/ratingsetdetails/" + this.formData.id, payload: this.formData})
                .then((res) => {
                    if (res.data.error) {
                        vm.isErr = !vm.isErr;
                        if (Array.isArray(res.data.error)) {
                            vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                        } else {
                            vm.errMsg = res.data.error;
                        }
                    } else {
                        const index = this.detailItem.findIndex(item => item.id === this.formData.id);
                        if (index !== -1) {
                            this.detailItem.splice(index, 1, { ...this.formData });
                        }
                        this.ratingdialog = false;
                        this.isEdit = false;
                        this.resetSelections();
                    }
                })
                .catch((err) => {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err;
                    console.log("err", err);
                });
            } else { //Add
                if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
                    return false;
                }

                this.$store.dispatch('post', {url: "/ratingsetdetails/create", payload: this.formData})
                .then((res) => {
                    if (res.data.error) {
                        vm.isErr = !vm.isErr;
                        if (Array.isArray(res.data.error)) {
                            vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                        } else {
                            vm.errMsg = res.data.error;
                        }
                    } else {
                        this.detailItem.push(res.data.result);
                        this.ratingdialog = false;
                        this.resetSelections();
                    }
                })
                .catch((err) => {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err;
                    console.log("err", err);
                });
            }
        },

        closeRatingInput() {
            this.ratingdialog = false;
            this.isErr = false;
            this.isEdit = false;

            // reset the form fields
            this.resetSelections();
        },

        resetSelections() {
            this.formData = {
                pmratesetid: this.parentObject.pmratesetid,
                rating: null,
                label: null,
                description: null,
                score: null,
                rectimestamp: null,
                updatedby: this.$store.getters.userId,
                stamp: 0,
                userid: this.$store.getters.userId,
            }
        },          
    },

    mounted() {
    }
}
</script>

<style>

.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-outer-spin-button,
.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-inner-spin-button
{
-webkit-appearance: none;
margin: 0;
}
</style>